export const LocalStorageKeys = {
  BRIDGE_TX_HIST_KEY: "bridge_tx_history",
  BRIDGE_TX_FAILED_KEY: "bridge_tx_failed",
  MANUAL_CLAIM_TX_HIST_KEY: "manual_claim_tx_history",
  CLAIM_INFO_KEY: "claim_info",
  L2_TOKEN_REG_KEY: "l2_token_reg",
  TOKEN_REG_TX_HASH_KEY: "token_reg_tx_hash",
  SHIELDING_USER_ADDED_TOKENS: "shielding_user_added_tokens",
  SHIELDING_TX_HIST_KEY: "shielding_tx_history",
  TRANSFER_TX_HIST_KEY: "transfer_tx_history",
} as const;
